import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

/**
 * Every 155 game is provably fair — each round's outcome is committed
 * (as a SHA-256 fingerprint) before betting closes and reproducible from
 * the revealed seed after it settles. So rather than surfacing internal
 * odds-model jargon ("Fixed Odds" / "Equal Odds") or pace ("Fast Race"),
 * each lobby card carries a single, universal trust seal. The odds model
 * itself still lives in the game rules and the in-game fairness panel.
 */
export function GameCardTags() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="game-entry-tags">
      <div className="game-entry-tag provably-fair">
        <svg
          aria-hidden
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        <span>{t('Provably Fair')}</span>
      </div>
    </div>
  )
}
